// extracted by css-extract-rspack-plugin
export default {"container":"container-jYH3a2"};